import React, { useContext } from "react";
import { ClinicaContext } from "../../../context/clinica-context";
import PdfAtestado from "./PdfAtestado";
import PdfAtestadoModelo2 from "./PdfAtestadoModelo2";

const MODELOS = {
  modelo1: PdfAtestado,
  modelo2: PdfAtestadoModelo2,
};

function PdfAtestadoWrapper({ showPreviousPage, atestadoData }) {
  const clinica = useContext(ClinicaContext);
  const modeloKey =
    clinica?.clinica?.configuracoes?.configuracoes?.modelosDocumentos
      ?.atestado || "modelo1";
  const Modelo = MODELOS[modeloKey] ?? PdfAtestado;

  return (
    <div>
      <Modelo atestadoData={atestadoData} showPreviousPage={showPreviousPage} />
    </div>
  );
}

export default PdfAtestadoWrapper;
